/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 Table — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: caption color via NS fg-subtle token (mode-aware) i.p.v.
// MUI default palette.text.secondary. Overige Table-styling staat op TableRow/TableCell.

export const MuiTableLightOverrides = {
  root: {
    display: 'table' as const,
    width: '100%',
    borderCollapse: 'collapse' as const,
    borderSpacing: 0,
    '& caption': {
      padding: 16,
      color: 'var(--ns-color-fg-subtle)',
      textAlign: 'left' as const,
      captionSide: 'bottom' as const,
    },
  },

  stickyHeader: {
    borderCollapse: 'separate' as const,
  },
} as const;

// Dark variant — token --ns-color-fg-subtle is mode-aware via tokens.css.
export const MuiTableDarkOverrides = {
  ...MuiTableLightOverrides,
} as const;
